"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSLATED_TTS_UPDATED_EVENT = exports.SUPPORTED_IMAGE_EXTENSIONS = exports.SUPPORTED_DOCUMENT_EXTENSIONS = exports.SUPPORTED_VIDEO_EXTENSIONS = exports.SUPPORTED_AUDIO_EXTENSIONS = void 0;
exports.SUPPORTED_AUDIO_EXTENSIONS = [
    '.m4a',
    '.webm',
    '.mp3',
    '.aac',
    '.wma',
    '.wav',
    '.wmv',
    '.ts',
    '.ogg',
    '.au',
    '.aif',
    '.vob',
    '.m4v',
    '.mkv',
    '.mov',
    '.avi',
    '.mp4'
];
exports.SUPPORTED_VIDEO_EXTENSIONS = [
    '.vob',
    '.webm',
    '.mpeg',
    '.mpg',
    '.mp4',
    '.flv',
    '.wmv',
    '.m4v',
    '.mov',
    '.mkv',
    '.mts',
    '.avi'
];
exports.SUPPORTED_DOCUMENT_EXTENSIONS = ['.zip', '.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
exports.SUPPORTED_IMAGE_EXTENSIONS = ['.gif', '.jpg', '.jpe', '.jpeg', '.png', '.bmp', '.webp'];
exports.TRANSLATED_TTS_UPDATED_EVENT = 'translated-tts-updated';
